'use strict';

import React from 'react';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

/**
 * Displays a Modal if browser cookies are disabled.
 */

class Cookies extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            showModal: true
        };

        this.hideModal = this.hideModal.bind(this);
    }

    hideModal = () => this.setState({showModal: false});

    render() {
        return (
            <Modal id="modal-cookies"
                   show={this.state.showModal}
                   className="modal-styled modal-primary"
                   size="sm"
                   aria-labelledby="modal-cookies-title"
                   centered>
                <Modal.Header>
                    <Modal.Title id="modal-cookies-title">Cookies are disabled</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Your browser has cookies disabled. To use of all features, you have to enable cookies in your
                        browser settings.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant="primary" onClick={this.hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default Cookies;